import { Injectable } from "@angular/core";
import { CreateBookingWS } from "@app/core/booking/data/network/create-booking.ws";
import { BookingRepo } from "@app/core/booking/domain/booking-repo";
import { Booking } from "@app/core/booking/domain/model/booking";
import { ShareMessageRepo } from "@app/core/share-message/domain/share-message.repo";
import { ShareMessageCapacitor } from "@app/core/share-message/infrastructure/capacitor/share-message.capacitor";
import { ShareMessageDesktopWeb } from "@app/core/share-message/infrastructure/desktop-web/share-message.desktop-web";
import { ShareMessageMobileWeb } from "@app/core/share-message/infrastructure/mobile-web/share-message.mobile-web";

import { Observable } from "rxjs";

@Injectable()
export class ShareMessageDesktopWebImplRepo implements ShareMessageRepo {
  constructor(private shareMessageDesktopWeb: ShareMessageDesktopWeb) {}

  shareMessage(message: string, url: string): Observable<string> {
    return this.shareMessageDesktopWeb.execute(message, url);
  }
}
